export default __webpack_public_path__ + "static/media/companyLogoPlaceholder.77fed1b9.png";